import React from "react";
import { Editor } from "@tinymce/tinymce-react";

interface RichTextEditorProps {
  value: string;
  onChange: (content: string) => void;
  label?: string;
  height?: number;
  disabled?: boolean;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  label,
  height = 500,
  disabled = false,
}) => {
  return (
    <div style={{ marginBottom: "1rem" }}>
      {label && (
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          {label}
        </label>
      )}
      <Editor
        apiKey="1k8hqjtja6fedyua4f9em16nvc5fotysoaqf92es69hg3ilo"
        value={value}
        onEditorChange={(newContent) => onChange(newContent)}
        init={{
          height,
          readonly: disabled,
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
            "emoticons",
            "autosave",
            "directionality",
            "visualchars",
            "template",
            "pagebreak",
            "nonbreaking",
            "toc",
            "textpattern",
            "codesample",
            "noneditable",
            "quickbars",
            "save",
            "tableofcontents",
          ],
          toolbar: `undo redo | blocks | bold italic underline strikethrough | 
             alignleft aligncenter alignright alignjustify | 
             bullist numlist outdent indent | link image media | 
             forecolor backcolor emoticons | code fullscreen preview | 
             insertdatetime table template | help`,
          toolbar_mode: "sliding",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
    </div>
  );
};

export default RichTextEditor;
